import type { RouteConfig } from '@/types/routestypes'
import React, { lazy ,memo } from 'react'

const TaskSettingPage = lazy(() => import("@/pages/TaskSetting/TaskSettingPage"));

const TaskSettingRoute: RouteConfig = {
    path: "tasksetting",
    pageName: "Task Setting",
    sidebar: { show: true, icon: "" },
    permission: ["TaskSetting"], 
    element: < TaskSettingPage />,
}

export default TaskSettingRoute
